export const BUTTON_ELEMENT = 'button';
export const SELECT = 'select';
export const ITEM_SELECT = 'itemSelect';
export const DATE_RANGE = 'dateRange';
export const DOWNLOAD_COUNT = 'downloadCount';
export const ADD_ELEMENT = 'addElement';
export const LANGUAGES_COUNT = 'languagesCount';